<template>
  <a-modal :visible="visible" :closable="false">
    <h6 class="mt-2 text-center">
      {{ $t(isShopee ? 'store_list_page.disconnect_modal.shopee_info' : 'store_list_page.disconnect_modal.confirm_title') }}
    </h6>
    <template #footer>
      <a-button key="back" :loading="loading" class="mr-2" @click="closeModal()">
        {{ $t(isShopee ? 'store_list_page.disconnect_modal.close' : 'store_list_page.disconnect_modal.cancel') }}
      </a-button>
      <a-button
        v-if="!isShopee"
        key="submit"
        :loading="loading"
        type="primary"
        @click="submitModal()"
      >
        {{ $t('store_list_page.disconnect_modal.confirm') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>

export default {
  name: 'ModalDisconnectStore',
  props: {
    visible: Boolean,
    back: Function,
    data: Object,
    loading: Boolean,
  },
  computed: {
    isShopee() {
      return ['shopee', 'shopee_id'].includes(this.data?.channelCode)
    },
  },
  methods: {
    closeModal() {
      this.$emit('handleShowModal', false)
    },
    submitModal() {
      if (this.isShopee) return
      this.$emit('handleSubmitModal', this.data)
    },
  },
}
</script>

<style lang="scss" module>
</style>
